// extracted by mini-css-extract-plugin
export default {"webcamera":"WebCamera_webcamera__yPM9S","webcamera__container":"WebCamera_webcamera__container__VNCOD","showFade":"WebCamera_showFade__gX25q","hideFade":"WebCamera_hideFade__xuFQw"};